const CHAT_MANAGEMENT_EXPERIENCE_TYPES = {
  CREATE_MESSAGE: '[chatManagementExperience] createMessage',
  EDIT_MESSAGE_CATEGORY: '[chatManagementExperience] editMessageCategory',
  FETCH_CHAT_GROUP_MESSAGES: '[chatManagementExperience] fetchChatGroupMessages',
  CREATE_CHAT_GROUP: '[chatManagementExperience] createChatGroup',
  EDIT_CHAT_GROUP: '[chatManagementExperience] editChatGroup',
  DELETE_CHAT_GROUP: '[chatManagementExperience] deleteChatGroup',
  PATCH_CHAT_GROUP_PHOTO: '[chatManagementExperience] patchChatGroupPhoto',
  UPDATE_CHAT_GROUP_MEMBER_ASSIGNATION: '[chatManagementExperience] updateChatGroupMemberAssignation',
  UPDATE_CHAT_GROUP_MEMBERS: '[chatManagementExperience] updateChatGroupMembers',
  SUBSCRIBE_CONTEXT: '[chatManagementExperience] subscribeContext',
  UNSUBSCRIBE_CONTEXT: '[chatManagementExperience] unsubscribeContext',
  REFRESH_UNREAD_SOURCES: '[chatManagementExperience] refreshUnreadSources',
  MARK_ACTIVE_THREAD_READ: '[chatManagementExperience] markActiveThreadRead'
}

export default CHAT_MANAGEMENT_EXPERIENCE_TYPES
